import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprControlVisibility } from '../props/IWprControlState';
import { WprControlInfo } from '../../view/control/WprControlInfo';
import { WprFramework } from '../../WprFramework';
import { WprBaseInputControlComponent } from './WprBaseInputControlComponent';

/**
 * チェックボックスプロパティ情報
 */
interface IWprCheckBoxProps extends IWprControlProps {
	beforeLabel?: string,		// 前ラベル
	afterLabel?: string			// 後ラベル
}

/**
 * チェックボックスコントロール
 */
export class WprCheckBox extends WprBaseInputControlComponent<IWprCheckBoxProps, HTMLInputElement> {
	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprCheckBoxProps) {
		super(props);
		this.setChangeValueEvent(this.onChangeValue.bind(this));
	}
	// --------------------------------------------------------------------------

	// イベント  ----------------------------------------------------------------
	/**
	 * 値変更処理
	 * @param event 変更イベント 
	 */
	public onChangeValue(event: React.ChangeEvent<HTMLInputElement>): void {
		const value = event.target.checked;
		// const name = event.target.name;
		if (this.controlInfo != null) {
			WprControlInfo.isChangeValue = true;
			try {
				WprFramework.getInstance().view.setScopeUpdateProperty();
				this.controlInfo.dirty = true;
				this.controlInfo.value = value;
				if (this.controlInfo.changeValue(value) === false)
					return;
				this.controlInfo.viewCore.viewInfo.checkScopeModelValue();
			}
			finally {
				WprControlInfo.isChangeValue = false;
			}
		}
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps('wpr-checkbox');
		const {name, view, className, beforeLabel, afterLabel, children, ...other} = this.props;
		let clsName = this.className('wpr-checkbox');
		const state = this.getState(['style', 'disabled', 'readOnly']);
		const events = this.getEvents();
		let checkBox = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			checkBox = <input type='checkbox' {...props} {...state} {...other} {...events}/>;
		}
		else {
			state['style'] = {...this.state.style, visibility: 'hidden'};
			checkBox = <input type='checkbox' {...props} {...state} {...other} />;
		}
		if ((this.props.beforeLabel || this.props.afterLabel) && this.props.id) {
			if (this.state.visibility === WprControlVisibility.VISIBLE)
				checkBox = <label className='wpr-checkbox-label' htmlFor={this.props.id}>{this.props.beforeLabel}{checkBox}{this.props.afterLabel}</label>;
			else
				checkBox = <label className='wpr-checkbox-label' htmlFor={this.props.id} style={{visibility: 'hidden'}}>{this.props.beforeLabel}{checkBox}{this.props.afterLabel}</label>;
		}
		return (
			<>
				{checkBox}
			</>
		);
	}

	/**
	 * プロパティ情報取得
	 * @param cls オリジナルクラス
	 * @returns プロパティ情報
	 */
	protected getProps(cls?: string): any {
		const rtn: any = {};
		rtn['name'] = this.getName();
		rtn['className'] = this.className(cls);
		const value = this.getValue();
		rtn['checked'] = false;
		if (value !== undefined) {
			if (value === true)
				rtn['checked'] = true;
		}
		return rtn;
	}

	/**
	 * プロパティチェック処理
	 */
	public onCheckProps(): void {
		if ((this.props.beforeLabel || this.props.afterLabel) && !this.props.id) {
			if (this.props.beforeLabel)
				this.addErrorLog(`beforeLabel(${this.props.beforeLabel})を指定した場合は、idを指定してください。[${this.props.name}]`);
			else
				this.addErrorLog(`afterLabel(${this.props.afterLabel})を指定した場合は、idを指定してください。[${this.props.name}]`);
		}
	}
	// --------------------------------------------------------------------------
}